"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerProfileStencil = exports.partnerProfileStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.partnerProfileStencilDefinition = {
    view: {
        label: 'Partner profile',
        category: 'group',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['logos'],
        contentAreas: [
            {
                name: 'main',
                items: ['title', 'description'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'website',
                            'statement',
                            'logos',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
        ],
    },
    content: {
        [properties_1.descriptionPropertyDefinition.name]: properties_1.descriptionPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.websitePropertyDefinition.name]: properties_1.websitePropertyDefinition,
        [properties_1.statementPropertyDefinition.name]: properties_1.statementPropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
    },
    roles: [],
    localizations: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'partner-profile',
};
const isPartnerProfileStencil = (stencil) => {
    return stencil.name === exports.partnerProfileStencilDefinition.name;
};
exports.isPartnerProfileStencil = isPartnerProfileStencil;
//# sourceMappingURL=data:application/json;base64,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